import ChatBot from "../../../../shared/components/chatBot";
import React from "react";
import { useParticipantDetails } from "../../context/participantDetails";
import { useRegDetail } from "../../../../shared/context/regDetail";
import { useConsent } from "../../../../context/consent";

export default function MyExpChatBotWrapper() {
  const { participantDetails } = useParticipantDetails();
  const { chatBotVendorType, chatBotVendorKey } = useRegDetail();
  const { hasStoredCookieConsent } = useConsent();
  if (!participantDetails?.registrationParticipantId || !chatBotVendorKey || !hasStoredCookieConsent) {
    return null;
  }
  return (
    <ChatBot
      chatBotVendorType={chatBotVendorType}
      botApiKey={chatBotVendorKey}
      userId={participantDetails?.registrationParticipantId}
      userName={`${participantDetails.firstName || ""} ${participantDetails.lastName || ""}`}
    />
  );
}
